import { useEffect } from "react";
import { useMap } from "react-leaflet";

export default function InvalidateMapSizeOnMount() {
    const map = useMap();

    useEffect(() => {
        const delays = [0, 50, 150, 400];
        const timers = delays.map((delay) => window.setTimeout(() => {
            map.invalidateSize({ animate: false });
        }, delay));

        return () => timers.forEach((id) => window.clearTimeout(id));
    }, [map]);

    useEffect(() => {
        const container = map.getContainer();
        if (!container || typeof ResizeObserver === "undefined") return undefined;

        const observer = new ResizeObserver(() => {
            map.invalidateSize({ animate: false });
        });
        observer.observe(container);

        return () => observer.disconnect();
    }, [map]);

    return null;
}
